
import { Options, Vue } from "vue-property-decorator";

export interface MenuItem {
  idx: number;
  name: string;
  path: string;
  show: boolean;
  current?: boolean;
}

@Options({
  props: {
    menuItems: Object,
  },
})
export default class SideMenu extends Vue {
  private menuItems!: MenuItem[];
  private menuWidth!: number;

  private showSidebar = true;
  private showLink = true;

  mounted(): void {
    // initialise menuItem state
    // get current state
    const _currentItem: MenuItem[] = this.menuItems.filter(m => {
      return m.current;
    });
    // preset all states to false
    for (let i = 0; i < this.menuItems.length; i++) {
      this.menuItems[i].current = false;
    }
    // check if currentItem defined
    if (_currentItem.length > 0) {
      this.menuItems[_currentItem[0].idx].current = true;
    } else {
    // set the first item as current
      this.menuItems[0].current = true;
    }

  }

  private menuClicked(key: number) {
    for (let i = 0; i < this.menuItems.length; i++) {
      this.menuItems[i].current = false;
    }
    this.menuItems[key].current = true;
    this.$emit('menuSelected', key);
  }

  private showNav() {
    if (this.showSidebar) {
      this.showLink = false;
      setTimeout(() => {
        this.showSidebar = false;
        this.menuWidth = 94;
        this.$emit('menuClosed', this.menuWidth);
      }, 250);
    } else {
      this.showSidebar = true;
      setTimeout(() => {
        this.menuWidth = 230;
        this.$emit('menuClosed', this.menuWidth);
        this.showLink = true;
      }, 250);
    }
  }

}


